import Vue from "vue";

Vue.component("party-annexes", {
    props: ["partyId", "searchParameterSearchTerm", "searchParameterAnnexNumbers", "homePartyId"],
    data() {
        return {
            rankTooltip: window.labels.rankTooltip,
            loading: false,
            annexes: [],
            searchTermOperation: 'ANY'
        };
    },
    methods: {
        getByPartyId() {
            const self = this;

            self.loading = true;
            self.$services.annexes.getByPartyId({
                partyId: self.partyId,
                searchParameterSearchTerm: self.searchParameterSearchTerm,
                searchParameterAnnexNumbers: self.searchParameterAnnexNumbers,
                searchTermOperation: self.searchTermOperation,
                language: window.currentLanguage,
            }).then((data) => {
                self.loading = false;
                self.annexes = data;
            });
        },
        extractOperation() {
            const self = this;

            let result = 'ANY';

            const searchTerm = self.searchParameterSearchTerm;

            if (searchTerm != null && searchTerm != undefined && searchTerm != "" && searchTerm != " ") {
                if (searchTerm.indexOf('"') >= 0 && searchTerm.indexOf('*') > 0) {
                    result = 'WILDCARD';
                }
                else if (searchTerm.indexOf('"') >= 0) {
                    result = 'EXACT';
                }
                else if (searchTerm.indexOf('&') > 0) {
                    result = 'AND'
                }
                else if (searchTerm.indexOf('|') > 0) {
                    result = 'OR';
                }
                else {
                    result = 'ANY';
                }
            }

            self.searchTermOperation = result;
        },
        getAnnexUrl(id, number) {
            let url = '';

            if (this.homePartyId != null && this.homePartyId != '') {
                url = `${eval("window.urls.annex" + number)}/${id}?homePartyId=${this.homePartyId}`;
            }
            else {
                url = `${eval("window.urls.annex" + number)}/${id}`;
            }

            return url
        },
        getDocImageFile(document) {
            let fileName = 'doc.png';
            switch (document.language) {
                case 'English':
                    fileName = 'doc_en.png';
                    break;
                case 'French':
                    fileName = 'doc_fr.png';
                    break;
                case 'Spanish':
                    fileName = 'doc_es.png';
                    break;
            }

            return '/images/' + fileName;
        },
        getDocTooltip(document) {
            let tooltip = window.labels.llsLinkAlt;
            return tooltip.replace('{0}', document.language);
        },
    },
    mounted() {
        const self = this;
        self.extractOperation();
        self.getByPartyId();
    },
    template: `
		<div class="browse-party-annexes">
			<template v-if="loading"><loading></loading></template>
			<template v-else>
				<b-table :data="annexes" detail-key="id">
					<b-table-column width="100%">
						<template v-slot="props">
							<a :href="getAnnexUrl(props.row.id, props.row.number)">
								<span v-html="props.row.displayName"></span>
							</a>
							<template v-if="props.row.documents != null && props.row.documents.length > 0">								
								<a style="float: right" class="browse-annex-lls-link pr-2" v-for="document in props.row.documents" :href="document.document" :title="getDocTooltip(document)" target="_blank">
									<img :src="getDocImageFile(document)" />
								</a>
							</template>
							<template v-if="props.row.rank">
								<b-tooltip :label="rankTooltip" multilined class="annex-rank-icon mr-2">
									<i data-toggle="tooltip" title="" :class="'fa fa-flag ' + props.row.rankClass"></i>
								</b-tooltip>
							</template>
						</template>
					</b-table-column>
				</b-table>
			</template>
		</div>
	`
});